module.exports = __webpack_public_path__ + "static/media/targeting_mobile_en.a32577a1.png";